// Add your custom JS here.

function makeSureHeaderIsNotOnTopOfSiteWideNotice() {

	var siteWideNotice = document.getElementById('topbar-notice');
	var noticeHeight = (typeof(siteWideNotice) != 'undefined' && siteWideNotice != null) ? siteWideNotice.clientHeight : 0;

	var navbar = document.getElementById('wrapper-navbar');

	if (!navbar) return;
	
	navbar.style.top = noticeHeight + 'px';

}

makeSureHeaderIsNotOnTopOfSiteWideNotice();

window.addEventListener("DOMContentLoaded", makeSureHeaderIsNotOnTopOfSiteWideNotice);

let resizeTimer1;

window.addEventListener("resize", () => {
	clearTimeout(resizeTimer1);
	resizeTimer1 = setTimeout(makeSureHeaderIsNotOnTopOfSiteWideNotice, 300); // 300ms after the last resize event
});

/*
function makeSureFooterIsAtTheBottom() {

	var checkIfIsMainSite = document.body.classList.contains("the-main-site");
	console.debug('[checkIfIsMainSite]', checkIfIsMainSite);

	// if (checkIfIsMainSite) return;

	var footer = document.getElementById('the-page-footer');
	// var footerHeight = footer.clientHeight;
	var footerHeight = footer.offsetHeight;
	footerHeight += 100;

	console.debug('[footerHeight]', footerHeight)

	document.getElementById('page').style.paddingBottom = footerHeight + 'px';

	footer.style.position = 'absolute';
	footer.style.bottom = '0';
	footer.style.left = '0';
	footer.style.right = '0';


}

makeSureFooterIsAtTheBottom();

let resizeTimer2;

window.addEventListener("resize", () => {
	clearTimeout(resizeTimer2);
	resizeTimer2 = setTimeout(makeSureFooterIsAtTheBottom, 300); // 300ms after the last resize event
});
*/
